import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const faqs = [
  {
    q: 'What is One Catalyst?',
    a: 'One Catalyst is a trusted problem‑solving partner for private clients and business families across capital, government, land and special situations.',
  },
  {
    q: 'What kind of matters can you help with?',
    a: 'We help with capital and transactions, government and regulatory matters, land and assets, strategic relationships, complex business matters and special situations.',
  },
  {
    q: 'How does One Catalyst work?',
    a: 'Bring us the matter. We understand the situation, identify the right path and people, and coordinate across relevant stakeholders to help move it forward.',
  },
  {
    q: 'Who do you typically work with?',
    a: 'We primarily work with HNIs, promoters, entrepreneurs, business families and family offices.',
  },
  {
    q: 'How can I engage One Catalyst?',
    a: 'You can engage us for a single matter, an ongoing relationship across multiple matters, or a bespoke engagement for situations requiring deeper involvement.',
  },
  {
    q: 'Is the relationship confidential?',
    a: 'Yes. Discretion and confidentiality are fundamental to how we work, particularly with sensitive personal, family and business matters.',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="px-4 md:px-6 pt-6 md:pt-8">
      <div className="max-w-7xl mx-auto bg-white rounded-[32px] md:rounded-[40px] px-6 md:px-12 py-20 md:py-28 border border-neutral-200">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 reveal">
            <span className="inline-block text-[11px] font-semibold tracking-[0.2em] uppercase text-neutral-800 bg-neutral-100 border border-neutral-200 px-3 py-1.5 rounded-full">
              FAQs
            </span>
            <h2 className="font-display-bold mt-6 text-4xl md:text-[56px] leading-[1.05] text-neutral-900">
              Questions, <span className="relative inline-block">
                <span className="relative z-10">answered.</span>
                <span className="absolute -inset-x-1 bottom-1 md:bottom-2 h-2 md:h-4 -z-0 rounded bg-[#E8DBC6]" />
              </span>
            </h2>
            <p className="mt-6 text-neutral-600 text-base md:text-lg leading-relaxed max-w-md">
              Everything you might want to know before you reach out. If a question isn’t here, write to the office — we’ll come back privately.
            </p>
          </div>

          <div className="lg:col-span-7 reveal">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} className="border border-neutral-200 rounded-2xl px-5 md:px-6 mb-3 bg-neutral-50 data-[state=open]:bg-white">
                  <AccordionTrigger className="text-left font-display-bold text-base md:text-lg text-neutral-900 py-5 hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-neutral-600 text-[14.5px] leading-relaxed pb-5 pr-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
